var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.393 25.848l-4.949.707.707-4.95L25.879 8.877a3 3 0 114.242 4.243L17.393 25.848zM7 2.749a.75.75 0 01.75-.75h8.5a.75.75 0 01.75.75v2.5a.75.75 0 01-.75.75h-8.5a.75.75 0 01-.75-.75v-2.5z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.999h4a2 2 0 012 2M23 25.999v4a2 2 0 01-2 2H3a2 2 0 01-2-2v-24a2 2 0 012-2h4M7 11.999h10M7 17.999h4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTaxData;